export default __webpack_public_path__ + "static/media/37.662e4af0.png";